import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { EntitlementComponent } from './entitlement/entitlement.component';
import { ServiceComponent} from './service/service.component';

const routes: Routes = [
  { path: '',  component: EntitlementComponent },
  { path: 'entitlement', component: EntitlementComponent },
  { path: 'identity', component: ServiceComponent },
  { path: 'developer_portal', component: ServiceComponent }
];

@NgModule({
  imports: [ RouterModule.forRoot(routes) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts